import React from 'react';

interface ExternalLinkIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export const ExternalLinkIcon: React.FC<ExternalLinkIconProps> = ({
  size = 16,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <mask id="mask0_7386_19242" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
        <rect x="0.5" width="24" height="24" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_7386_19242)">
        <path d="M8.55775 16H19.9423C20.0193 16 20.0898 15.9679 20.1538 15.9038C20.2179 15.8398 20.25 15.7692 20.25 15.6923V6H8.25V15.6923C8.25 15.7692 8.28208 15.8398 8.34625 15.9038C8.41025 15.9679 8.48075 16 8.55775 16ZM8.55775 17.5C8.05258 17.5 7.625 17.325 7.275 16.975C6.925 16.625 6.75 16.1974 6.75 15.6923V4.30775C6.75 3.80258 6.925 3.375 7.275 3.025C7.625 2.675 8.05258 2.5 8.55775 2.5H19.9423C20.4474 2.5 20.875 2.675 21.225 3.025C21.575 3.375 21.75 3.80258 21.75 4.30775V15.6923C21.75 16.1974 21.575 16.625 21.225 16.975C20.875 17.325 20.4474 17.5 19.9423 17.5H8.55775ZM5.05775 21C4.55258 21 4.125 20.825 3.775 20.475C3.425 20.125 3.25 19.6974 3.25 19.1923V6.30775H4.75V19.1923C4.75 19.2693 4.78208 19.3398 4.84625 19.4038C4.91025 19.4679 4.98075 19.5 5.05775 19.5H17.9423V21H5.05775Z" fill={color}/>
      </g>
    </svg>
  );
}; 